import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaClock, FaMapMarkerAlt, FaEnvelope, FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import './footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__container">
                <div className="footer__section">
                    <h3 className="footer__title">Contáctanos</h3>
                    <div className="footer__contact-item">
                        <FaPhone className="footer__icon" />
                        <div>
                            <p className="footer__contact-label">Líneas de atención:</p>
                            <p className="footer__contact-info">(1) 6331002</p>
                            <p className="footer__contact-info">316 251 9103</p>
                        </div>
                    </div>
                    <div className="footer__contact-item">
                        <FaClock className="footer__icon" />
                        <div>
                            <p className="footer__contact-label">Horario de atención:</p>
                            <p className="footer__contact-info">Lun - Vie: 8:00 AM - 5:00 PM</p>
                        </div>
                    </div>
                    <div className="footer__contact-item">
                        <FaEnvelope className="footer__icon" />
                        <div>
                            <p className="footer__contact-label">Correo electrónico:</p>
                            <p className="footer__contact-info">contacto@99envios.com</p>
                        </div>
                    </div>
                </div>

                <div className="footer__section">
                    <h3 className="footer__title">Nuestras Sedes</h3>
                    <div className="footer__location-item">
                        <FaMapMarkerAlt className="footer__icon" />
                        <div>
                            <h4 className="footer__location-country">Colombia</h4>
                            <p className="footer__location-address">
                                Carrera 105 a 70 a 09
                                <span>Bogotá, Colombia</span>
                            </p>
                        </div>
                    </div>
                  
                
                    <div className="footer__social">
                        <a href="#" className="footer__social-link"><FaFacebookF /></a>
                        <a href="#" className="footer__social-link"><FaTwitter /></a>
                        <a href="#" className="footer__social-link"><FaInstagram /></a>
                        <a href="#" className="footer__social-link"><FaLinkedinIn /></a>
                    </div>
                </div>

                <div className="footer__section">
                    <h3 className="footer__title">Enlaces Rápidos</h3>
                    <nav className="footer__nav">
                        <Link to="/">Inicio</Link>
                        <Link to="/servicios">Nuestros Servicios</Link>
                        <Link to="/rastreo">Rastrear Envío</Link>
                        <Link to="/tablero">Panel de Control</Link>
                        <Link to="/create/usuario">Crear Cuenta</Link>
                        <Link to="/contacto">Contacto</Link>
                    </nav>
                </div>
            </div>
            
            <div className="footer__bottom">
                <div className="footer__copyright">
                    <p>&copy; 2024 99envios - Innovación en logística y envíos</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;